export default __webpack_public_path__ + "static/media/background-earth.dark.fa2ba405.png";